import ImageLogo from "assets/images/logo.png";
import ImageLogoMobile from "assets/images/logo-mob.png";
import ImageProject from "assets/images/projects/project.png";
import ImageSeason1 from "assets/images/projects/s1.png";
import ImageSeason2 from "assets/images/projects/s2.png";
import ImageSeason2Color from "assets/images/projects/s2-color.png";
import ImageIggy from "assets/images/projects/iggy.png";
import ImageIggyColor from "assets/images/projects/iggy-color.png";
import ImageAthStudio from "assets/images/projects/1ath-studio.png";
import ImageAthStudioColor from "assets/images/projects/1ath-studio-color.png";
import ImageVideoPreview from "assets/images/video-preview.png";

const images = {
    ImageLogo,
    ImageLogoMobile,
    ImageProject,
    ImageSeason1,
    ImageSeason2,
    ImageSeason2Color,
    ImageIggy,
    ImageIggyColor,
    ImageAthStudio,
    ImageAthStudioColor,
    ImageVideoPreview,
};

export default images;

export type ImagesType = keyof typeof images;